/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Tip_1Inputs */

const tr_katalog_desi_page_tip_1 = /** @type {(inputs: Katalog_Desi_Page_Tip_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ölçüleri kolinin dış cephesinden alın (paketleme dahil).`)
};

const en_katalog_desi_page_tip_1 = /** @type {(inputs: Katalog_Desi_Page_Tip_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measure the outside of the box (including packaging).`)
};

const de_katalog_desi_page_tip_1 = /** @type {(inputs: Katalog_Desi_Page_Tip_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messen Sie die Außenseite des Kartons (inkl. Verpackung).`)
};

const ru_katalog_desi_page_tip_1 = /** @type {(inputs: Katalog_Desi_Page_Tip_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Измеряйте коробку снаружи (включая упаковку).`)
};

/**
* | output |
* | --- |
* | "Measure the outside of the box (including packaging)." |
*
* @param {Katalog_Desi_Page_Tip_1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_tip_1 = /** @type {((inputs?: Katalog_Desi_Page_Tip_1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Tip_1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_tip_1(inputs)
	if (locale === "de") return de_katalog_desi_page_tip_1(inputs)
	if (locale === "ru") return ru_katalog_desi_page_tip_1(inputs)
	return tr_katalog_desi_page_tip_1(inputs)
});